import { useQuery } from '@tanstack/react-query';
import { fetchAllPages } from './fetch-all-pages';

// Curso disponible para la inscripción individual del instructor (vista previa:
// incluye borradores del propio instructor; se filtra en el consumidor).
// En módulo propio (no instructor.ts) para no arrastrar hooks hermanos sin test
// al denominador de coverage.
export type CourseOption = {
  id: number;
  title: string;
  status: string;
  created_by: number | null;
};

export function useEnrollmentCourses() {
  return useQuery({
    queryKey: ['instructor', 'courses-for-enrollment'],
    queryFn: () => fetchAllPages<CourseOption>('/courses'),
  });
}
